import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

type VinLinkProps = {
  vin: string;
  label?: string;
  compact?: boolean;
  stopPropagation?: boolean;
  className?: string;
  variant?: 'accent' | 'muted';
};

export function VinLink({
  vin,
  label,
  compact = false,
  stopPropagation = false,
  className,
  variant = 'accent',
}: VinLinkProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={(event) => {
        if (stopPropagation) {
          event.stopPropagation();
        }

        navigate(`/vin/${encodeURIComponent(vin)}`);
      }}
      className={cn(
        'inline-flex items-center font-medium tracking-[-0.1px] underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30',
        variant === 'accent'
          ? 'intl-action-link'
          : 'text-foreground underline transition-colors hover:text-[var(--intl-accent)]',
        compact ? 'text-[14px]' : 'text-[15px]',
        className,
      )}
    >
      {label ?? vin}
    </button>
  );
}
